import { setVw } from './utils/vwUtils';
import { initHamburgerMenu } from './utils/hamburgerUtils';
import { initGnavSubToggle } from './utils/gnavSubToggleUtils';
import { initFadeSlider } from './utils/sliderUtils';
import { initYearSelects, initBirthdaySelect } from './utils/selectFormUtils';
import { initPrivacyAgreement } from './utils/privacyAgreementUtils';
import { initEntryTime } from './utils/entryTimeUtils';


window.addEventListener("load", () => {
  document.body.classList.add("is-loaded");
});

document.addEventListener('DOMContentLoaded', () => {
  initHamburgerMenu();
  initGnavSubToggle();
  initFadeSlider();
  initYearSelects();
  initBirthdaySelect();
  initPrivacyAgreement();
  initEntryTime();
  setVw();
  // ...以下、必要に応じて増設
});

window.addEventListener('resize', () => {
  setVw();
});